module.exports = __webpack_public_path__ + "static/media/EyeOrganizations.159bc10f.svg";